import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "text-big" }
const _hoisted_3 = { style: {"white-space":"nowrap"} }

import { ref } from "vue";
import axios from "axios";
import { Modal } from "uiv";

import { CustomReportApiModel } from "../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'custom-report-deleter',
  props: {
    group: {},
    deleteUrlBase: {}
  },
  emits: ["dialog-closed", "dialog-opened", "deleted"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const errors = ref<string[]>([]);

const shown = ref(false);

function close(): void {
  shown.value = false;
  setTimeout(() => {
    emit("dialog-closed");
  }, 1000);
}

function cancel(): void {
  close();
}

function open(): void {
  setTimeout(() => {
    shown.value = true;
  }, 200);
  emit("dialog-opened");
}

function doDelete(): void {
  axios
    .delete(`${props.deleteUrlBase}/${props.group.id}`.replace("//", "/"))
    .then(() => {
      errors.value = [];
      close();
      emit("deleted");
    })
    .catch(() => {
      errors.value = ["There was a problem. Please check your internet connection and try again."];
    });
}

const getGroup = (): CustomReportApiModel => {
  return props.group;
};

__expose({
  open,
  close,
  cancel,
  getGroup,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    class: "custom-report-deleter text-left",
    "append-to-body": true,
    modelValue: shown.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shown).value = $event)),
    title: 'Delete ' + ((_ctx.group.name || '').length > 0 ? _ctx.group.name : 'Untitled Report') + '?'
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-primary btn-lg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (doDelete())),
          type: "button"
        }, "Delete"),
        _createElementVNode("button", {
          class: "btn btn-default btn-lg",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (cancel())),
          type: "button"
        }, "Cancel")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(" Are you sure you want to delete the custom report "),
          _createElementVNode("span", _hoisted_3, "'" + _toDisplayString(_ctx.group.name) + "'?", 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "text-danger text-left",
            key: error
          }, _toDisplayString(error), 1))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})